import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { stepSchema, stepSchemaReIdentification } from '../validationSchema';
import { TGettingStarted } from '../types';
import { getingStartedInitialValues } from '../utils';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext';
import { useEffect } from 'react';
import {
  selectCompletedForms,
  selectGettingStarted,
  selectIsReidentification,
} from '~/store/identification-form/selectors';

export const useGettingStartedForm = (isExisting: boolean, step: number) => {
  const { isGettingStartedCompleted } = useSelector(selectCompletedForms) || {};
  const isReidentification = useSelector(selectIsReidentification);
  const gettingStarted = useSelector(selectGettingStarted);
  const { isSoleTrader } = useGetContragentTypes();
  const {
    isCRSIFopEnabled,
    isOwnershipStructureTreeEnabled,
    isAdditionalInformationAboutTaxResidencyEnabled,
  } = useFeatureFlags();

  const initialValues = getingStartedInitialValues(gettingStarted);

  const schema = isReidentification
    ? stepSchemaReIdentification(
        isExisting,
        step,
        isSoleTrader,
        !!isGettingStartedCompleted,
        isCRSIFopEnabled,
        isAdditionalInformationAboutTaxResidencyEnabled,
        isOwnershipStructureTreeEnabled
      )
    : stepSchema(
        isExisting,
        step,
        isSoleTrader,
        !!isGettingStartedCompleted,
        isCRSIFopEnabled,
        isAdditionalInformationAboutTaxResidencyEnabled,
        isOwnershipStructureTreeEnabled
      );

  const form = useForm({
    resolver: yupResolver(schema) as unknown as Resolver<TGettingStarted>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: initialValues,
  });

  useEffect(() => {
    if (!gettingStarted?.applicationId) return;

    setTimeout(() => {
      form.reset(getingStartedInitialValues(gettingStarted), {
        keepDefaultValues: false,
        keepErrors: false,
      });
    }, 0);
  }, [gettingStarted?.applicationId]);

  return form;
};
